import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "../TextError";
import "./styles.scss";
import Tooltip from "@material-ui/core/Tooltip";
import exclamationcircleblue from "../../../Assets/exclamationcircleblue.svg";

function Input(props) {
  const { label, name, disabled, maxLen, urlChecker, onClick, hidden, inputValue, ...rest } = props;

  const validate = (value) => {
    let errorMessage;
    let pattern =
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
      if(name == "createRelease.appBuildVersion"){
        return errorMessage
      }
    if (name !== "dust" &&  value && value.length < 3){
      errorMessage = "Minimum 3 characters required";
    }
    if (urlChecker && !pattern.test(value)) errorMessage = "Url is not valid";
    return errorMessage;
  };

  return (
    <>
      <label htmlFor={name} className="xs-lable-select white" required>
        {label}
        {props.required === false ? null : (
          <span style={{ color: "red" }}>{` *`}</span>
        )}
      </label>
      {props.tooltip && (
        <Tooltip title={props.tooltip} placement="right">
          <img
            src={exclamationcircleblue}
            alt="logo"
            // className="fluid logo"
            style={{
              width: "0.7rem",
              height: "0.7rem",
              cursor: "pointer",
              marginLeft: "0.25rem",
            }}
          />
        </Tooltip>
      )}
      <div
        onClick={onClick}
        className={`primary_input ${
          props.name === "generatedKey" ? "copy-logo" : ""
        }`}
      >
        {
          inputValue ? 
          <Field
          value={inputValue}
          validate={validate}
          maxLength={maxLen}
          autoComplete="nope"
          id={name}
          disabled={disabled}
          style={{ ...(disabled && {color: "#707070"}) , ...(hidden && {caretColor:  "#ffffff00"})}}
          name={name}
          {...rest}
          className={"input-text-dropdown"}
        />: 
        <Field
          validate={validate}
          maxLength={maxLen}
          autoComplete="nope"
          id={name}
          disabled={disabled}
          style={{ ...(disabled && {color: "#707070"}) , ...(hidden && {caretColor:  "#ffffff00"})}}
          name={name}
          {...rest}
          className={"input-text-dropdown"}
        />
        }
        {/* <Field
          validate={validate}
          maxLength={maxLen}
          autoComplete="nope"
          id={name}
          disabled={disabled}
          style={{ ...(disabled && {color: "#707070"}) , ...(hidden && {caretColor:  "#ffffff00"})}}
          name={name}
          {...rest}
          className={"input-text-dropdown"}
        /> */}
        <ErrorMessage component={TextError} name={name} />
      </div>
    </>
  );
}

export default Input;
